<template>
  <div class=" a justify-content-md-center">
    <label class="form-control-label">{{ label }}</label>
    <span v-if="required" class="text-red"> *</span>
    <multiselect
      v-model="selectedUser"
      :options="users"
      :disabled="isDisabled"
      label="name"
      :placeholder="'Selecionar ' + label"
      track-by="id"
      :loading="loading"
      :multiple="multiple"
      @search-change="debouncedGetUsers"
      @bottom-reached="loadMoreUsers"
      :limit="-Infinity"
      :close-on-select="closeOnSelect"
    >
      <template v-if="multiple == true" slot="beforeList" class="" >
        <div
          @click="toggleSelectAll" 
          :class="allSelected ? 'all-selected ' : 'multiple select-all-option'" 
          :style="allSelected ? 'background-color: #e9ecef; color: #212529' : ''"
        >
          <span :style="allSelected ? 'font-weight: 700' : ''">{{ allSelected ? 'desmarcar todos' : 'selecionar todos' }}</span>
        </div>
      </template>
 
      <template v-slot:limit>
        <strong v-if="firstSelectedUserName"  class="multiselect__strong mr-1">{{ firstSelectedUserName }}
          <div class=" multiselect__tag-icon" @click="remove(selectedUser[0])" ></div>
        </strong>
        <span v-if="selectedUsersCount >= 1" class="multiselect__strong-counter">+ {{ selectedUsersCount }}</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

export default {
  name: 'UserMultiselect',
  components: {
    Multiselect,
  },
  props: {
    value: {
      required: true
    },
    userType: {
      type: String,
      default: ''
    },
    filter: {
      type: Object,
      default: ''
    },
    label: {
      type: String,
      default: 'Usuário',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    location: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false 
    },
    multiple: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    nameOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      users: [],
      loading: false,
      pagination: {
        page: 1,
        per_page: 10,
      },
      current: 1,
      getUsersTimeout: null,
      totalUsers: 0
    };
  },
  mounted() {
    this.getUsers()
  },
  methods: {
    remove(option) {
      this.selectedUser = this.selectedUser.filter(user => user.id !== option.id);
    },
    async getUsers(query, current) {
      const data = {
        page: current,
        per_page: this.pagination.per_page,
        q: { name: query, status: this.active },
      };
      
      if (this.userType && this.userType === 'manager') {
        data.q.is_manager = true;
      } else if (this.userType && this.userType === 'salesman') {
        data.q.is_salesman = true;
      } else if (this.userType && this.userType === 'coordinator') { 
        data.q.is_coordinator = true;
      } else if(this.userType && this.userType === 'mkt_manager') {
        data.q.is_mkt_manager = true;
      } else if(this.userType && this.userType === 'seed_manager') {
        data.q.is_seed_manager = true;
      } else if(this.userType && this.userType === 'seed_coordinator') {
        data.q.is_seed_coordinator = true;
      } else if(this.userType === 'support') {
        data.q.subject_class = "demand_support";
        data.q.action = 4;
      }

      if (this.nameOnly) data.name_only = this.nameOnly;

      if (this.filter.role && this.filter.role.id) {
        data.q.role_id = this.filter.role.id
      }
      if (this.filter.manager && this.filter.manager.id) {
        data.q.manager_id = this.filter.manager.id;
      }
      if (this.filter.manager && this.filter.manager.coordinated_id) {
        data.q.manager_id = this.filter.manager.coordinated_id;
      }
      if (this.filter.anosafra && this.filter.anosafra.id) {
        data.q.anosafra_id = this.filter.anosafra.id;
      }
      if (this.location) {
        data.uf = this.location.toUpperCase();
      }
      this.loading = true;
      try {
        const response = await this.$http.secured.get('/api/v1/users', { params: data });
        let newUsers = [];

        if (this.nameOnly == true) {
          newUsers = response.data || [];
           this.totalUsers = response.data.length;
        } else {
          newUsers = response.data.users || [];
          this.totalUsers = response.data.count;
        }
        
        if (current === 1) {
          this.users = newUsers;
        } else {
          const uniqueUsers = newUsers.filter(newUser => !this.users.some(user => user.id === newUser.id));
          this.users = [...this.users, ...uniqueUsers];
        }

        if (this.allSelectedActive) {
          this.selectedUser = [...new Set([...this.selectedUser, ...newUsers])];
        }

      } catch (error) {
        console.error('[UserMultiselect][getUsers]', error);
      } finally {
        this.loading = false;
      }
    },
    loadMoreUsers(){
      if (this.loading) return;
      if (this.users.length == this.totalUsers) return; 
      this.pagination.page += 1
      this.getUsersTimeout = setTimeout(
        () => this.getUsers(null, this.pagination.page),
        600
      );
    },
    debouncedGetUsers(query) {
      if (this.getUsersTimeout) clearTimeout(this.getUsersTimeout);

      this.getUsersTimeout = setTimeout(
        () => this.getUsers(query),
        600
      );
    },
    toggleSelectAll() {
      if (this.allSelected) {
        this.selectedUser = [];
        this.allSelectedActive = false;
      } else {
        this.selectedUser = [...this.users];
        this.allSelectedActive = true;
      }
    },
    clear(){
      this.selectedUser = [];
    }
  },
  watch: {
    'filter.anosafra': {
      handler: function () {
        this.users = [];
        this.getUsers('', this.current);
      },
      deep: true,
    },
    'filter.manager': {
      handler: function () {
        if (this.userType === 'salesman') {
          this.selectedUser = [];
          this.users = this.filter.manager ? this.filter.manager.salesmans : [];
          this.getUsers('', this.current);
        }
      },
      deep: true,
    },
  },
  computed: {
    deselectedFromAll() {
      if (!this.allSelectedActive) return [];

      return this.users.filter(user => !this.selectedUser.some(selectedUser => selectedUser.id == user.id));
    },
    allSelected() {
      return (
        this.users.length &&
        this.selectedUser &&
        this.selectedUser.length === this.users.length
      );
    },
    selectedUser: {
      get() {
        return this.value;
      },
      set(value) {
        if (!this.multiple || (Array.isArray(value))) return this.$emit('input', value);
        
        const newValue  = [...this.value];
        const itemIndex = newValue.findIndex(item => item.id === value.id);

        if (itemIndex !== -1) newValue.splice(itemIndex, 1);
          
        this.$emit('input', newValue);
      }
    },
    firstSelectedUserName() {
      return this.selectedUser && this.selectedUser[0] && this.selectedUser[0].name;
    },
    selectedUsersCount() {
      if (this.allSelectedActive){
        return this.totalUsers - this.deselectedFromAll.length - 1;
      }

      if (!this.selectedUser) return 0;

      return this.selectedUser.length - 1;
    },
  }
};
</script>
<style scoped>
.multiple {
  cursor: pointer;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.multiple:hover {
  background-color: #41b883;
  color: white;
}
.multiselect__option--highlight {
  background-color: transparent !important;
  color: #35495e;
}

.multiselect__option:hover {
  background-color: #41b883  !important; 
  color: white;
}
.multiselect__strong {
  position: relative;
  margin-left: 7px;
  padding: 3px 25px 3px 10px !important;
}

.multiselect__strong-counter {
  position: relative;
  margin-left: 7px;
  padding: 3px 5px 3px 10px;
  color: #FFFFFF;
  font: 12px "Open Sans";
  background-color: #41B883;
  border-radius: 0.25rem;
}
.all-selected:hover {
  background-color: #41b883  !important; 
  color: white;
  height: 30px;
  padding: 12px 10px 30px 12px;
}
.all-selected {
  height: 30px;
  padding: 12px 10px 30px 12px;
  cursor: pointer;
}
.multiselect__option--selected.multiselect__option--highlight {
  background-color: rgb(239, 241, 244) !important;
  color: #35495e;
}

</style>
